// @ is an alias to /src
// Environment Variables
const { config } = require("@/config/index.js");

//import cookies from "@/assets/scripts/cookies.js";

import axios from "axios";

//const { token } = cookies;
//const { id } = cookies;

//const apiUrl = "https://flight-center-api-tau.vercel.app/api";
const apiUrl = "https://flight-center-api.herokuapp.com/api";

let options;

const setUser = (token, id) => {
  options = {
    withCredentials: true,
    credentials: "include",
    headers: {
      id,
      Authorization: `Bearer ${token}`,
      //"X-FP-API-KEY": "iphone",
      "Content-Type": "application/json",
    },
  };
};

// POST signUp
const signUp = async (user) => {
  const data = await axios({
    url: `${apiUrl}/auth/signUp`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(user),
  });
  //const data = await res.json();
  return data;
};

// POST signIn
const signIn = async (user) => {
  console.log("config-req", config);
  const data = await axios({
    url: `${apiUrl}/auth/signIn`,
    method: "POST",
    headers: {
      Authorization: `Basic ${btoa(`${user.userName}:${user.password}`)}`,
    },
    data: {
      apiKeyToken: config.adminApiKeyToken,
    },
  });
  //const data = await res.json();
  return data;
};

// GET users
const getUser = async (userId) => {
  const data = await axios({
    url: `${apiUrl}/users/${userId}`,
    method: "GET",
    ...options,
  });
  return data.data;
};

// Begin expenses methods
// .
// .
// .
// GET operations
const getOperations = async () => {
  console.log("getOperations options", options);

  const data = await axios({
    url: `${apiUrl}/operations`,
    method: "GET",
    ...options,
  });
  //const data = await res.json();

  /*if (isPieChart) return data.data;
  let expenses = data.data.map((result, index) => ({
    index: index + 1,
    id: result._id,
    amount: result.amount,
    type: "expense",
    category: {
      categoryId: result.category ? result.category.categoryId : "",
      name: result.category ? result.category.name : "",
    },
    notes: result.notes,
    date: result.createdAt,
  }));*/
  return data;
};

// POST create operation
const addOperation = async (operation) => {
  const res = await axios({
    url: `${apiUrl}/operations`,
    method: "POST",
    data: operation,
    ...options,
  });
  //const data = res;
  //console.log(data);
  return res; //data.message;
};

// UPDATE operation
const updateOperation = async (operation) => {
  const res = await axios({
    url: `${apiUrl}/operations/${operation.id}`,
    method: "PUT",
    data: JSON.stringify(operation),
    ...options,
  });
  //const data = await res.json();
  return res;
};

// DELETE operation
const deleteOperation = async (operation) => {
  console.log(operation.id);
  const res = await axios({
    url: `${apiUrl}/operations/${operation.id}`,
    method: "DELETE",
    ...options,
  });
  //const data = await res.json();
  return res;
};

// End expenses methods

// Begin clients methods
// .
// .
// .
// GET clients
const getClients = async () => {
  const res = await axios({
    url: `${apiUrl}/clients/`,
    method: "GET",
    ...options,
  });
  const data = res.data;
  //console.log(data);
  /*let incomes = data.data.map((result, index) => ({
    index: index + 1,
    id: result._id,
    amount: result.amount,
    type: "income",
    category: {
      categoryId: result.category ? result.category.categoryId : "",
      name: result.category ? result.category.name : "",
    },
    notes: result.notes,
    date: result.createdAt,
  }));*/
  return data;
};

// GET client
const getClient = async (payload) => {
  const res = await axios({
    url: `${apiUrl}/clients/${payload}`,
    method: "GET",
    ...options,
  });
  const data = res.data;
  //console.log(data);
  /*let incomes = data.data.map((result, index) => ({
    index: index + 1,
    id: result._id,
    amount: result.amount,
    type: "income",
    category: {
      categoryId: result.category ? result.category.categoryId : "",
      name: result.category ? result.category.name : "",
    },
    notes: result.notes,
    date: result.createdAt,
  }));*/
  return data;
};

// POST create client
const addClient = async (payload) => {
  const res = await axios({
    method: "POST",
    url: `${apiUrl}/clients`,
    data: payload,
    ...options,
  });
  return res;
};

// PUT update income
const updateClient = async (client) => {
  const res = await axios({
    url: `${apiUrl}/incomes/${client.id}`,
    method: "PUT",
    body: JSON.stringify(client),
    ...options,
  });
  //const data = await res.json();
  return res;
};

// DELETE delete client by id
const deleteClient = async (incomeId) => {
  const res = await axios({
    url: `${apiUrl}/incomes/${incomeId}`,
    method: "DELETE",
    ...options,
  });
  //const data = await res.json();
  return res;
};

// End incomes methods

// Begin sales methods
// .
// .
// .
// GET sale
const getSale = async (payload) => {
  const res = await axios({
    url: `${apiUrl}/sales/${payload}`,
    method: "GET",
    ...options,
  });
  const data = res.data;
  /*console.log(res, data);*/
  /*const data = await res.json();
  let categories = data.data.map((result) => ({
    categoryId: result._id,
    name: result.name,
  }));*/
  return data;
};

// POST sale
const addSale = async (sale) => {
  const res = await axios({
    url: `${apiUrl}/sales`,
    method: "POST",
    data: sale,
    ...options,
  });
  //const data = await res.json();
  //const data = res;
  //console.log(data);
  return res; //data.message;
};

// End categories methods

// End categories methods

// Begin promotions methods
// .
// .
// .
// GET promotions
const getPromotions = async () => {
  const res = await axios({
    url: `${apiUrl}/promotions`,
    method: "GET",
    ...options,
  });
  return res.data;
};

// POST sale
const addPromotion = async (promotion) => {
  const res = await axios({
    url: `${apiUrl}/promotions`,
    method: "POST",
    data: promotion,
    ...options,
  });
  return res;
};

// Begin promotions methods
// .
// .
// .
// GET promotions
const getNotifications = async () => {
  const res = await axios({
    url: `${apiUrl}/notifications`,
    method: "GET",
    ...options,
  });
  return res.data;
};

// POST sale
const addNotification = async (notification) => {
  const res = await axios({
    url: `${apiUrl}/notifications`,
    method: "POST",
    data: notification,
    ...options,
  });
  return res;
};

export default {
  setUser,
  signUp,
  signIn,
  getUser,
  getOperations,
  addOperation,
  updateOperation,
  deleteOperation,
  getClients,
  getClient,
  addClient,
  updateClient,
  deleteClient,
  getSale,
  addSale,
  getPromotions,
  getNotifications,
  addPromotion,
  addNotification,
};
